import {SortableTable} from "components/tables/SortableTable";
import { useUser } from "contexts/UserContext";
import { doc, FieldPath, getDoc, getDocs, getFirestore, updateDoc } from "firebase/firestore";
import { useQuarterId } from "hooks/UseQuarterId";
import { useDocumentData, useDocumentDataOnce } from "react-firebase-hooks/firestore";
import { Link, useParams } from "react-router-dom";
import { PepTeacherContext } from "./ExamPrepTeacherContext";
import { useContext, useEffect, useState } from "react";
import { FaCheck } from "react-icons/fa";
import styled from "styled-components";

export const ExamPrepTeacherSplash = () => {

  console.log("ExamPrepTeacherSplash")
  const qtrId = useQuarterId();
  const firestore = getFirestore();
  const examId = useParams().examId;
  console.log(examId)
  const {
    slotsData,
    slotToStudent,
    classData,
    signupsData,
    isPepTeacherContextLoading,
    isPepTeacherContextError
  } = useContext(PepTeacherContext);

  const [publishedStatuses, setPublishedStatuses] = useState({});

  // Fetch all taScores for each student in parallel
  const fetchTaScoresForStudents = async () => {


    const promises = [];

    // Loop through each student and create a promise for fetching taScores
    for (const studentId in signupsData) {
      if (studentId) {
        const taScoresPath = `personalexamprep/${qtrId}/${examId}/students/${studentId}/private/ta/scores`;
        console.log(taScoresPath)
      
        const taScoresDocRef = doc(firestore, taScoresPath);
        // Push the promise to the array
        promises.push(getDoc(taScoresDocRef).then((docSnap) => ({
          studentId,
          taScoresData: docSnap.exists() ? docSnap.data() : null,
        })));
      }
    }

    // Wait for all promises to resolve
    const results = await Promise.all(promises);

    // Process results and update the publishedStatuses map
    const statusMap = {};
    results.forEach(({ studentId, taScoresData }) => {
      console.log(taScoresData)
      statusMap[studentId] = taScoresData?.isPublished || false;
    });

    setPublishedStatuses(statusMap);
  };

  useEffect(() => {
    fetchTaScoresForStudents();
  }, [slotToStudent]);

  console.log(publishedStatuses)

  if (isPepTeacherContextLoading) {
    return <></>;
  }

  if (isPepTeacherContextError) {
    return <p>Error 500: {isPepTeacherContextError}</p>;
  }

  const data = createDataTable(slotsData, slotToStudent, classData, publishedStatuses);

  const timeSortFunction = (a, b) => {
    if (a === b) {
      return 0;
    }

    // Ensure that a and b are valid date strings that can be parsed by Date
    const dateA = new Date(a);
    const dateB = new Date(b);

    // Check if both dateA and dateB are valid Date objects
    if (isNaN(dateA.getTime()) || isNaN(dateB.getTime())) {
      console.error('Invalid date format:', { a, b });
      return 0; // Fallback: no sorting if invalid dates are encountered
    }

    // Return the difference in time to sort by date
    return dateA.getTime() - dateB.getTime();
  };

  const customSortFunctions = {
    "Time": timeSortFunction,
    "Published": (a, b) => { return 0 },
    "Location": (a,b) => {return 0}
  };


  return <>
    <SortableTable
      data={data}
      defaultSortKey={"Time"}
      customSortFunctions={customSortFunctions} sortKey={undefined} sortDir={undefined} onSortChange={undefined} rowKey={undefined}    />
  </>
}

const createDataTable = (slotsData, slotToStudent, classData, publishedStatuses) => {

  const studentIdToDataMap = parseClassData(classData);
  const data = []
  for (const slotId in slotsData) {
    const slot = slotsData[slotId]
    const studentId = slotToStudent[slotId]
    const studentData = studentIdToDataMap[studentId]

    data.push({
      'Time': `${slot.date}, ${slot.time}`,
      'TA': slot.ta,
      'Location': <EditableLocationCell slotId={slotId} initialValue={slot.location} />,
      'Student': studentData ? StudentLink(studentData) : '',
      'Student Email': studentData ? studentData.email : '',
      'TA Email': slot.email.toLowerCase(),
      'Published': <PublishedCheck
        publishedStatuses={publishedStatuses}
        studentId={studentId}
      />
    })
  }
  return data
}

const EditableLocationCell = ({ slotId, initialValue }) => {
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState(initialValue ?? "");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const qtrId = useQuarterId();
  const examId = useParams().examId;
  const firestore = getFirestore();

  useEffect(() => {
    // keep in sync if parent data changes
    setValue(initialValue ?? "");
  }, [initialValue]);

  const save = async (nextVal) => {
    const trimmed = (nextVal ?? "").trim();
    if (trimmed === (initialValue ?? "").trim()) {
      setEditing(false);
      return;
    }
    try {
      setSaving(true);
      setError("");
      const ref = doc(firestore, `personalexamprep/${qtrId}/${examId}/slots`);
      await updateDoc(ref, new FieldPath(slotId, "location"), trimmed);
      setEditing(false);
    } catch (e) {
      console.error(e);
      setError("Failed to save");
    } finally {
      setSaving(false);
    }
  };

  const onKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      save(value);
    } else if (e.key === "Escape") {
      e.preventDefault();
      setValue(initialValue ?? "");
      setEditing(false);
      setError("");
    }
  };

  if (!editing) {
    return (
      <LocationButton
        type="button"
        onClick={() => setEditing(true)}
        title="Click to edit location"
        
      >
        {value || <>TBD</>}
      </LocationButton>
    );
  }

  return (
      <LocationInput
        autoFocus
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={onKeyDown}
        onBlur={() => save(value)}
        disabled={saving}
        style={{ minWidth: 150 }}
        placeholder="Location"
      />
  );
};

const LocationButton = styled.button`
  width:200px;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  text-align:left;
  min-height:30px;
  display: block; 
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  direction: rtl;
  text-align: left;
`;

const LocationInput = styled.input`
  width:200px;
`

const PublishedCheck = ({ publishedStatuses, studentId }) => {

  const isPublished = publishedStatuses[studentId]
  if (isPublished) {
    return <FaCheck />

  }
  return <></>
}

const StudentLink = (studentData) => {
  const qtrId = useQuarterId()
  const examId = useParams().examId
  const url = `/${qtrId}/pep/${examId}/ta/${studentData.uid}`
  return <Link to={url}>{studentData.name}</Link>
}

const parseClassData = (classData) => {
  const students = classData.students
  // students is an array of objects
  const studentIdToDataMap = {}
  for (const student of students) {
    studentIdToDataMap[student.uid] = student
  }
  return studentIdToDataMap
}

